module.exports = __webpack_public_path__ + "assets/media/user-member-lovel01.7f11e0b0.png";